import React, { useEffect, useMemo, useState } from "react";
import TableComponent from "../../TableComponent/TableComponent";
import DuplicatesTabTableColumn from "./DuplicatesTabTableColumn";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import {
  closeCreateMergeRequestModal,
  openCreateMergeRequestModal,
  fetchDuplicateBrand,
  fetchPaginateDuplicateBrand,
  resetDuplicateBrandTable,
  updateDuplicateBrandRequestBody,
} from "../../../redux/LivePlatform/LivePlatformAction";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import CreateMergeRequestModal from "./CreateMergeRequestModal";

function DuplicatesTabComponent(props: { onTabChange: (key: string) => void }) {
  const dispatch = useAppDispatch();
  const duplicateBrandState = useSelector(
    (state: RootState) => state.livePlatformState.duplicateBrandState
  );
const createMergeRequestModalOpenState = useSelector(
    (state: RootState) => state.livePlatformState.duplicateBrandState.CreateMergeDuplicateBrandState.createMergeRequestModalState
  );

  const [selectedRecord, setSelectedRecord] = useState<any>(null);

  const handleOpenModal = (record: any) => {
    setSelectedRecord(record);
    dispatch(openCreateMergeRequestModal())
  };
  const columns = useMemo(() => {
    return DuplicatesTabTableColumn(handleOpenModal); // pass modal handler
  }, []);
  function handleTableSorting(sortOrder: any): void {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }
      return false;
    };
    const newSortingRequestBody = {
      ...duplicateBrandState.currentRequestBody,
      SortColumn: sortOrder.field,
      isAsc: isAscend(sortOrder.order),
    };
  
     dispatch(resetDuplicateBrandTable());
     dispatch(updateDuplicateBrandRequestBody(newSortingRequestBody));
       dispatch(fetchDuplicateBrand(newSortingRequestBody));
  }

  return (
    <div className="body-container pt-3 h-100 gap-3" key={0}>
      <TableComponent
        columns={columns}
        dataSource={duplicateBrandState.duplicateBrandDetails}
        pagination={duplicateBrandState.pagination}
        handleTableSorting={handleTableSorting}
        loading={duplicateBrandState.loading}
        fetchPaginatedData={() => fetchPaginateDuplicateBrand({})}
        tableKey="DuplicateBrandTable"
      />
      <CreateMergeRequestModal
        openState={createMergeRequestModalOpenState}
        open={() => dispatch(openCreateMergeRequestModal())}
        close={() => dispatch(closeCreateMergeRequestModal())}
        domain={selectedRecord?.website}
        setTabKey={() => props.onTabChange("1")}
      />
    </div>
  );
}
export default DuplicatesTabComponent;
